// Maps a winner's party to its color class (.dem-winner, .rep-winner,
// .lib-winner, .gre-winner, .ind-winner). Uses the same three-letter prefix
// as PartyPill, so it doesn't depend on exact party spellings.
function winnerClass(party: string, contestResult?: string): string {
  if (contestResult == 'runoff') return 'runoff-winner';
  if (!party) return '';

  return `${party.slice(0, 3).toLowerCase()}-winner`;
}

export default winnerClass;
